import { auth, functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

export const TriggerFetchLatestDocForDownload = async ({ 
  reportStage, 
  clinicianId, 
  patientId,
  fileFormat = 'pdf' // Default to PDF if not specified
}) => {

  const fetchLatestDocumentForDownload = httpsCallable(functions, 'fetchLatestDocumentForDownload'); 

  const user = auth.currentUser;
  if (!user || !user.uid) return; // Ensure user is loaded

  try {
    const result = await fetchLatestDocumentForDownload({
      report_stage: reportStage,
      clinician_id: clinicianId,
      patient_id: patientId,      
      file_format: fileFormat,
    });    

    // Check if the operation was successful
    if (result.data.status !== "success") {
      return { success: false, error: result.data.message || "Unknown error occurred" };
    }

    // Get the download URL directly from the response
    const { downloadUrl, filename } = result.data;

    // Create a temporary link and trigger download
    const link = document.createElement('a');
    link.href = downloadUrl;
    
    // Set download filename with appropriate extension based on format
    const extension = fileFormat.toLowerCase();
    link.download = filename || `${reportStage.replace(/\s+/g, '')}_Report.${extension}`;
    
    // Set target to _blank to prevent navigating away from the current page
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    
    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return { 
      success: true,
      expiresAt: result.data.expiresAt // In case you need to show expiration info
    };

  } catch (error) {
    console.error('Error calling fetchLatestDocumentForDownload function:', error);
    return { 
      success: false, 
      error: error.message || "Failed to download document" 
    };
  }
};